module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "table_collumns-col"
  }, [_c('div', {
    staticClass: "table_collumns-title"
  }, [_c('i', {
    class: _vm.banner,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.box_hits))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.total_visits')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.unanswered_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.visits_without_answers')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.uncompleted_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.quizzes_not_completed')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.completed_submissions_count))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.quizzes_completed')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.conclusion_rate))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.completion_rate')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table_collumns-line"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.metric.conclusion_average_time))]), _vm._v("\n    " + _vm._s(_vm.$t('report.metrics.average_time_to_complete')) + "\n  ")])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-277066a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/metrics/Device.vue
 ** module id = 783
 ** module chunks = 1
 **/